import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.climbStepOneExtraCollections.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.climbStepOneExtraCollections.data.currency,
  (currency = {}) => currency
);
const getCollectionsData = createSelector(
  (state) =>
    state.climbStepOneExtraCollections.data.climbStepOneExtraCollections,
  (collections = []) => collections
);
const getPageCount = createSelector(
  (state) => state.climbStepOneExtraCollections.data.pageCount,
  (pageCount) => pageCount || 0
);

export default {
  getCollectionsData,
  getCurrencyData,
  getHasLoaded,
  getPageCount,
};
